import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SmsMessage } from '../../lib';
import { AllFilter, ChatFilter } from './chat-filter/chat-filter.component';

@Injectable({
  providedIn: 'root'
})
export class ChatMessengerService {
  private responseTextSource = new BehaviorSubject<string>('');
  private syStudentIdSource = new BehaviorSubject<number | undefined>(undefined);
  private smsMessagesSource = new BehaviorSubject<SmsMessage[]>([]);
  private chatFilterSource = new BehaviorSubject<ChatFilter>(AllFilter);

  responseText = this.responseTextSource.asObservable();
  $activeSyStudentId = this.syStudentIdSource.asObservable();
  smsMessages = this.smsMessagesSource.asObservable();
  chatFilter = this.chatFilterSource.asObservable();

  constructor() { }

  setActiveStudentId(syStudentId: number|undefined) {
    this.syStudentIdSource.next(syStudentId)
  }

  setResponseText(responseText: string) {
    this.responseTextSource.next(responseText);
  }

  setSmsMessages(smsMessages: SmsMessage[]) {
    this.smsMessagesSource.next(smsMessages);
  }

  setChatFilter(filter: ChatFilter) {
    this.chatFilterSource.next(filter);
  }
}
